<template>
  <Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
  >
    <template slot="header">
      {{$t('add_artist')}}
    </template>
    <template slot="body">
      <SearchList
        :id="'artists'"
        :items="artists"
        :keyProperty="'artist_id'"
        :label="'artist_name'"
        :placeholder="'Search Artists'"
        @searched="onArtistsSearched"
      >
      <template v-slot:item="{ item }">
        <tr class="dt-table2--row">
          <td class="dt-table2--column checkbox-column">
            <div class="dt-checkbox v2 s1">
              <input
                type="checkbox"
                name="name"
                @click="(e) => onCheckboxChange(e, item)"
              />
              <div class="checkmark"></div>
            </div>
          </td>
          <td class="dt-table2--column">
            <span class="txtov">{{ item.artist_name }}</span>
          </td>
          <td class="dt-table2--column checkbox-column">
            <span class="txtov">
            <img
                v-if="item.exclusive == 'Conflict'"
                :src="`static/icons/artist-exclusivity/artist-exclusivity-inactive.svg`"
                class="dt-icon s1"
                style="cursor:auto;"
                :title="item.toooltip"
              />
            </span>
          </td>
        </tr>
      </template>
    </SearchList>
    </template>
    <template slot="options">
      <button class="dt-button s7" @click="onCancelClick"> {{$t('cancel')}} </button>
      <button class="dt-button v1 with-ico s7" @click="onOKClicked">
        <div class="dt-icon-container">
          <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
        </div>
        <div class="button-text">{{$t('add')}} {{$t('artist')}}</div>
      </button>
    </template>
  </Modal>
</template>

<script>
import * as R from "ramda";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import {
  BookingStoreNamespace as storeNS,
  BookingStoreNamespace
} from "../../store";
import * as ActionTypes from "../../store/types";
import { BookingService } from "../../services/booking-service";
import { addRemoveSet } from "../../../../utility";
import InputField from "../../../../plugins/text-field/input-field";

import Modal from '../../../../dt-plugins/modal/modal';
import SearchList from "@dtplugins/search-list/search-list";

export default {
  components: {
    InputField,
    Modal,
    SearchList
  },
  props: {
    booking: {
      type: Object,
      required: true
    },
  },
  data: function() {
    return {
      artists: [],
      searchString: "",
      selectedArtists: new Set(),
      searchSubject$: new Subject()
    };
  },
  computed: {
    calendarDateId: function() {
      return this.booking?.cdate?.calendar_date_id;
    },
    calendarDate: function() {
      return this.booking?.cdate?.start_date;
    }
  },
  mounted: function() {
    // console.error(this.calendarDateId, this.calendarDate);
    BookingService.findArtistsList({
      calendarDate: this.calendarDate,
      calendarDateId: this.calendarDateId
    }).then(res => {
      this.artists = res.data.artists;
      // console.log(res);
    });

    this.$subscribeTo(
      this.searchSubject$.asObservable().pipe(
        distinctUntilChanged(),
        debounceTime(300)
      ),
      searchString => {
        BookingService.findArtistsByName({
          calendarDateId: this.calendarDateId,
          search: searchString
        }).then(res => {
          this.artists = res.data.artists;
        });
        // console.warn(searchString);
      }
    );
  },
  methods: {
    onOKClicked: function() {
      BookingService.addArtists({
        calendarDateId: this.calendarDateId,
        calendarDate: this.calendarDate,
        artists: Array.from(this.selectedArtists).join(",")
      }).then(res => {
        // console.log(res);
        BookingService.loadArtist({
          calendarDateId: this.calendarDateId
        }).then(res => {
          this.$emit("done", res);
        });
      });
      // console.log(Array.from(this.selectedArtists).join(","));
    },
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },
    onCheckboxChange: function(event, artist) {
      this.selectedArtists = addRemoveSet(
        event.target.checked,
        this.selectedArtists,
        artist.artist_id
      );
    },
    onArtistsSelected: function(selectedArtists) {
      this.selectedArtists = selectedArtists;
    },
    onArtistsSearched: function(searchString) {
      BookingService.findArtistsByName({
          calendarDateId: this.calendarDateId,
          search: searchString
        }).then(res => {
          this.artists = res.data.artists;
        });
    },
    onSearchInputKeyup: function(event) {
      this.searchString = event.target.value;
      this.searchSubject$.next(event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.artists-container {
  height: 360px;
  overflow: auto;
  border: 1px solid var(--sprt-5);
  .artists {
    .artist-item {
      padding: 5px;

      .checkbox-container {
        padding: 5px 0px;
      }

      &:nth-child(8n),
      &:nth-child(8n-2),
      &:nth-child(8n + 3),
      &:nth-child(8n + 1) {
        background: var(--sprt-8);
      }
    }
  }
}
</style>
